import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/family/{family_account_id}/low_balance_level_data
export const lowBalanceNoticeLevel = async (familyAccountId: number) => {
  const response = await new Request().get(
    '/ajax/family/' + familyAccountId + '/low_balance_level_data'
  )
  return Util.Obj.keysToCamel(response.data.low_balance_level_data)
}
